import { render, staticRenderFns } from "./ProjectsPdf.vue?vue&type=template&id=cedc3b2a"
import script from "./ProjectsPdf.vue?vue&type=script&lang=js"
export * from "./ProjectsPdf.vue?vue&type=script&lang=js"
import style0 from "./ProjectsPdf.vue?vue&type=style&index=0&id=cedc3b2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports